import angular from 'angular';
import showDocumentListOnHover from './showDocumentListOnHover';
import './style.scss';

export default angular
  .module('components.showDocumentListOnHover', [])
  .component('showDocumentListOnHover', showDocumentListOnHover).name;
